import { Injectable } from '@angular/core';

import {
    AreaUnit,
    DistanceUnit,
    PcvizDBRegistry,
    PcvizSceneView,
    PcvizUserPreferences,
    PcvizWorkspaceController,
    VolumeUnit,
} from '@mirage-projects/cw-models';

import { ControllerDBType } from './controller-db-type';

@Injectable({ providedIn: 'root' })
export class DbPcvizService {
    getUtils(): typeof PointCloudViz.DB.Utils {
        return PointCloudViz.DB.Utils;
    }

    getListenerController(): typeof PointCloudViz.DB.ListenerController {
        return PointCloudViz.DB.ListenerController;
    }

    getUnitController(): typeof PointCloudViz.DB.UnitController {
        return PointCloudViz.DB.UnitController;
    }

    getInstanceDB(): PcvizDBRegistry {
        return PointCloudViz.DB.Registry.getInstance();
    }

    getControllerDB(controller: ControllerDBType): any {
        return PointCloudViz.DB.Registry.getController(controller);
    }

    registerController(nameController: ControllerDBType, controller: any): void {
        this.getInstanceDB().registerController(nameController, controller);
    }

    /* istanbul ignore next */
    getWorkspaceController(): PcvizWorkspaceController {
        return this.getControllerDB('Workspace');
    }

    getWorkspaceControllerSelectionModes(): { select: number; unselect: number } {
        return {
            select: PointCloudViz.DB.WorkspaceController.SELECT_MODE,
            unselect: PointCloudViz.DB.WorkspaceController.UNSELECT_MODE,
        };
    }

    /* istanbul ignore next */
    getAreaUnits(): AreaUnit[] {
        return this.getUnitController()._areaUnits;
    }

    /* istanbul ignore next */
    getDistanceUnits(): DistanceUnit[] {
        return this.getUnitController()._distanceUnits;
    }

    /* istanbul ignore next */
    getVolumeUnits(): VolumeUnit[] {
        return this.getUnitController()._volumeUnits;
    }

    /* istanbul ignore next */
    /**
     * Resets all listener controllers. Useful when loading a new project.
     */
    resetControllers(): void {
        this.getInstanceDB().resetControllers();
    }

    /* istanbul ignore next */
    /**
     * Gets the view 3d from the registry
     */
    getView3d(): PcvizSceneView {
        return this.getInstanceDB().getController('View').getView('3D');
    }

    getScanSelectionController(): any {
        return PointCloudViz.DB.ScanSelectionController;
    }

    getUserPreferences(): PcvizUserPreferences {
        return this.getControllerDB('UserPreferences');
    }
}
